// The CDN build's entry (dist/index.global.js). tsup wraps it in an IIFE whose result
// is the global namespace `CopeCart`, exactly as in 0.1.0, so pages written as
// `new CopeCart.CopeCart({...})` keep working and every export stays reachable as
// `CopeCart.<name>`. The class is also set as the global `Cope`, so a script tag reads
// `new Cope({...})`, the same as an import.
import { Cope } from './index.js'

export * from './index.js'

;(globalThis as { Cope?: typeof Cope }).Cope = Cope
